import styled from 'styled-components'
import { media } from '../../../../layouts/utils'
import { colorBrandPrimary } from '../../../../global.style'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'

export const Wrapper = styled.div`
  ${media.phone`
    height: content-fit;
    min-height: 500px;
    padding-left: 10px;
    padding-right: 10px;
  `}
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 500px;
  padding-top: 40px;
  background-color: ${colorBrandPrimary.marine}
`

export const Container = styled.div`
  max-width: 650px;
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Background = styled.img`
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  ${media.phone`
    width: 200%;
    left: -70%;
  `}
`

export const TextIntro = styled(Descricao)`
  color: ${props => props.cor};
  text-transform: uppercase;
  padding: 0;
  ${media.phone`
    font-size: 12px;
    line-height: 14px;
  `}
`

export const TitleContainer = styled.div`
  ${media.phone`
    width: 100%;
    max-width: 410px;
  `}
  display: inline-block;
  padding-bottom: 20px;
`

export const Title = styled(TituloPrincipal)`
  color: ${props => props.cor};
  ${media.desktop`
    padding-top: 0;
  `}
`

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;
  margin: 10px;
  button {
    width: 180px;
  }
`